
import { defineComponent } from 'vue';
import MainMenu from '@/components/nav/MainMenu.vue';
import HomeHeader from '@/components/home/HomeHeader.vue';

export default defineComponent({
    name: 'Home',
    components: {
        MainMenu,
        HomeHeader,
    },
});

